import React from 'react'

export const Space = () => <div className="flex-1" />
